export var Size;
(function (Size) {
    Size["SMALL"] = "SMALL";
    Size["MEDIUM"] = "MEDIUM";
    Size["LARGE"] = "LARGE";
})(Size || (Size = {}));
//# sourceMappingURL=size.enum.js.map